<template>
  <div class="c-ad-table">
    <el-table
      ref="table"
      class="common-el-table-styles summary-el-table-styles"
      :height="height"
      row-key="adId"
      v-loading="value"
      :data="data"
      :summary-method="getSummaries"
      :cell-class-name="cellClassName"
      show-summary
      stripe
      border
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <i-Switch v-model="scope.row.optStatus" :loading="scope.row.optLoading" @on-change="changeActive(scope.row)" size="small" />
            <Button v-if="scope.row.planId" type="primary" size="small" shape="circle">内</Button>
          </div>
          <div v-else-if="col.key === 'adName'">
            <a v-clipboard:copy="scope.row.adName" v-clipboard:success="onCopy">{{ scope.row.adName }}</a>
          </div>
          <div v-else-if="col.key === 'projectName'">
            <el-button type="text" @click="$emit('on-project-filter', scope.row)">{{ scope.row.projectName }}</el-button>
          </div>
          <span v-else-if="col.key === 'planTime'">{{ scope.row.planTime | adTouTime(scope.row) }}</span>
          <span v-else-if="['createTime', 'synTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button
              type="text"
              size="small"
              class="m-control-btn"
              @click="editClick(scope.row)"
              :disabled="allowControl(scope.row.adStatus)"
              >修改</el-button
            >
          </div>
          <span v-else-if="col.key.indexOf('Rate') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
          <!-- 出价 -->
          <div v-else-if="col.key === 'bid'">
            <div v-if="scope.row.editBid">
              <el-input
                placeholder=""
                v-model="scope.row.newbid"
                style="width: 50px"
                @blur="inputTrim('newbid', scope.row, true)"
              ></el-input>
              <Button type="primary" :loading="saving" size="small" @click="editBid(scope.row)">
                <span v-if="!saving">确定</span>
              </Button>
              <Button size="small" @click="cancelEdit(scope.row, 'editBid')">取消</Button>
            </div>
            <div v-else-if="scope.row.bid === null">-</div>
            <div v-else>
              <span>{{ scope.row.bid | toThousands }}</span>
              <Icon @click="changEdit(scope.row, 'editBid', 'bid')" type="md-create" class="m-edit" size="18" color="#409EFF" />
            </div>
          </div>
          <!-- 预算 -->
          <div v-else-if="col.key === 'budget'">
            <div v-if="scope.row.editBudget">
              <div class="buget-modify">
                <RadioGroup v-model="scope.row.budgetFlag" vertical>
                  <Radio :label="0" :disabled="true"><span>不限</span></Radio>
                  <Radio :label="1">
                    <el-input
                      class="buget-input"
                      v-model="scope.row.newbudget"
                      @blur="inputTrim('newbudget', scope.row, true)"
                      :disabled="!scope.row.budgetFlag"
                      style="width: 50px"
                    ></el-input>
                    <Button type="primary" size="small" :loading="saving" @click="editBudget(scope.row)">
                      <span v-if="!saving">确定</span>
                    </Button>
                    <Button size="small" @click="cancelEdit(scope.row, 'editBudget')">取消</Button>
                  </Radio>
                </RadioGroup>
              </div>
            </div>
            <div v-else-if="scope.row.budget === null">-</div>
            <div v-else>
              <span v-if="scope.row.budget > 0">{{ scope.row.budget | toThousands }}</span>
              <span v-else>不限</span>

              <Icon @click="changEdit(scope.row, 'editBudget', 'budget')" type="md-create" class="m-edit" size="18" color="#409EFF" />
            </div>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns" @on-ok="$emit('on-refresh')"></betch-error>
  </div>
</template>

<script>
import mixin from '../mixin'
import { mul, div } from '@/common/js/api'
import { toThousands } from '@/common/js/filters'
import { isArray, isEmpty, trim, setLocalInfo } from '@/common/js/utils'
import { batchoperator, modifyCpaBid, modifyAdBudget } from '@/api/convert.model'
import BetchError from '@/components/converter/betch-error.vue'

export default {
  name: 'projectTable',
  mixins: [mixin],
  components: {
    BetchError
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    inputTrim(key, row, fixed) {
      let val = parseFloat(row[key])
      if (isEmpty(val) || typeof val !== 'number') {
        this.$set(row, key, 0)
        return
      }
      val = trim(val)
      if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      } else val = parseInt(val)
      this.$set(row, key, val)
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    // 合计自定义
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let totalAmount = 0 // 总实际消耗
      let totalRegister = 0 // 总注册数
      let totalPaperAmount = 0 // 总账面消耗
      let totalConverterNum = 0 // 总转化数
      let convertCostIndex // 转化成本索引
      let registerCostIndex // 注册成本索引
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[prop]))
        if (
          [
            'budget',
            'paperAmount',
            'amount',
            'pv',
            'clickNum',
            'activeNum',
            'convertNum',
            'convertCost',
            'register',
            'registerCost',
            'payCount',
            'payAmount',
            'appCheckoutCount'
          ].includes(prop) &&
          !values.every((value) => isNaN(value))
        ) {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value) && value >= 0) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          // 用于求平均注册、转化成本
          if (column.property === 'amount') totalAmount = sum
          if (column.property === 'register') totalRegister = sum
          if (column.property === 'paperAmount') totalPaperAmount = sum
          if (column.property === 'convertNum') totalConverterNum = sum
          if (prop === 'convertCost') convertCostIndex = index
          if (prop === 'registerCost') registerCostIndex = index
          sums[index] = sum.toString().includes('.') ? toThousands(parseFloat(sum.toFixed(2))) : toThousands(sum)
        } else {
          sums[index] = ''
        }
      })
      sums[convertCostIndex] = totalConverterNum ? parseFloat(totalPaperAmount / totalConverterNum).toFixed(2) : totalPaperAmount.toFixed(2)
      sums[registerCostIndex] = totalRegister ? parseFloat(totalAmount / totalRegister).toFixed(2) : totalRegister
      return sums
    },
    // 修改跳转
    editClick(row) {
      setLocalInfo(row.accountId, row.accountName, 10)
      window.open(`/create/toutiaov2/adedit?id=${row.adId}&acId=${row.accountId}&t=edit`, '_blank')
    },
    // 开关
    changeActive(row) {
      let { optStatus } = row
      optStatus = optStatus ? 1 : 0
      if ([1, 0].includes(optStatus)) {
        row.optLoading = true
        this.betch(optStatus, [row])
      }
    },
    cellClassName({ column }) {
      if (column.property === 'budget' || column.property === 'bid') return column.property

      return ''
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },
    select(val) {
      this.selectList = val
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何项目，请在列表中选择一个或多个项目再进行此操作。'
        })
        return
      }

      // 删除二次验证
      if (type < 0) {
        this.$Modal.confirm({
          title: '提示',
          content: `<p>当前选中${len}条投放计划，确定删除吗？</p>`,
          onOk: () => {
            this.betch(type, this.selectList)
          }
        })
      } else {
        const seleIds = this.selectList.map((ret) => ret.planId)
        this.data.forEach((ret) => {
          this.$set(ret, 'optLoading', seleIds.includes(ret.planId))
        })
        this.betch(type, this.selectList)
      }
    },
    betch(type, row) {
      batchoperator({
        type,
        adIds: row.map((ret) => {
          return {
            projectId: ret.projectId,
            accountId: ret.accountId,
            adId: ret.adId,
            adName: ret.adName,
            mediaId: ret.mediaId
          }
        })
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            // 显示错误列表
            this.betchErr = rows
            this.betchShow = true
            this.data.forEach((ret) => {
              this.$set(ret, 'optLoading', false)
            })
            return
          } else if (failNum && row.length === 1) {
            this.$Message.error({
              duration: 5,
              content: rows[0].result
            })
            this.$set(row, 'optStatus', type === 0)
            this.$set(row, 'optLoading', false)
          } else {
            this.$Message.success({
              duration: 5,
              content: '操作成功'
            })
          }
          this.$emit('on-refresh')
        }
      })
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    onCopy() {
      this.$Message.success('复制计划名成功！')
    },
    // 改变编辑状态
    changEdit(row, key, feild) {
      let value = row[feild]
      if (value < 0) value = 0
      this.data.forEach((ret) => {
        this.$set(ret, key, false)
      })
      this.$set(row, `new${feild}`, value)
      this.$set(row, key, true)
    },
    cancelEdit(row, key) {
      this.saving = false
      this.$set(row, key, false)
    },
    // 修改单价
    editBid(row) {
      const bid = parseFloat(row.newbid)
      if (row.budget && bid > row.budget) {
        this.$Message.error({ duration: 5, content: '出价不能大于预算值' })
        return
      }
      if (bid < 0.1) {
        this.$Message.error({ duration: 5, content: '出价必须大于等于0.1' })
        return
      }

      this.saving = true
      modifyCpaBid({
        adAccountId: row.accountId,
        adId: row.adId,
        newBid: bid
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBid', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 修改预算
    editBudget(row) {
      let budget = parseFloat(row.newbudget)
      const lowBudget = 300 // 最低预算
      const maxBudget = 9999999.99 // 最高预算

      // 0：不限，1：日预算
      if (row.budgetFlag) {
        if (budget < lowBudget) {
          this.$Message.error({ duration: 5, content: `日预算应大于${lowBudget}元` })
          return
        }
        if (budget > maxBudget) {
          this.$Message.error({ duration: 5, content: `日预算应小于${maxBudget}元` })
          return
        }
      } else budget = 0

      this.saving = true
      modifyAdBudget({
        adId: row.adId,
        adAccountId: row.accountId,
        newAdbudget: budget
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'editBudget', false)
          this.$emit('on-refresh')
        }
      })
    },
    allowControl(status) {
      return status === 2
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      selectList: [], // 选中
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      betchColumns: [
        {
          key: 'adName',
          title: '计划名称',
          tooltip: true,
          minWidth: 140
        },
        {
          key: 'result',
          title: '操作结果',
          tooltip: true,
          minWidth: 250
        }
      ]
    }
  },
  filters: {
    convertInvenType(val, invenType) {
      const typeNames = []
      if (invenType && isArray(invenType)) {
        let wpa = []
        if (val && val.length) {
          wpa = val.split(',')
        }
        wpa.map((key) => {
          const arr = invenType.filter((ret) => ret.key === key)
          if (arr.length) {
            typeNames.push(arr[0].value)
          }
        })
      }
      return typeNames.length ? typeNames.join(',') : '未知'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-ad-table {
  position: relative;
  background-color: #fff;

  ::v-deep .el-table {
    .buget-modify {
      .buget-input {
        input {
          padding: 0 5px;
          height: 28px;
          line-height: 28px;
        }
      }
    }

    .bid,
    .budget {
      position: relative;

      &:hover {
        .m-edit {
          display: block;
        }
      }
      .m-edit {
        cursor: pointer;
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        display: none;
      }
    }
  }
}

// 合计列置顶
::v-deep dl.bid-custom-dl {
  dd,
  dt {
    display: inline-block;
  }
}
</style>
